import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { SocialProofBar } from '../components/SocialProofBar';
import { BetrayalSection } from '../components/BetrayalSection';
import { ScienceSection } from '../components/ScienceSection';
import { ThreePillars } from '../components/ThreePillars';
import { MidPageCTA } from '../components/MidPageCTA';
import { BlueprintContents } from '../components/BlueprintContents';
import { WhoIsThisFor } from '../components/WhoIsThisFor';
import { PriceAnchor } from '../components/PriceAnchor';
import { FinalCTA } from '../components/FinalCTA';
import { FloatingCTA } from '../components/FloatingCTA';
import { Footer } from '../components/Footer';
export function LandingPage({
  onNavigate
}: {
  onNavigate?: (page: string) => void;
}) {
  return <main className="min-h-screen bg-[#111111] text-white overflow-x-hidden" data-id="element-258">
      <HeroSection data-id="element-259" />
      <SocialProofBar data-id="element-260" />
      <BetrayalSection data-id="element-261" />
      <ScienceSection data-id="element-262" />
      <ThreePillars data-id="element-263" />
      <MidPageCTA data-id="element-264" />
      <BlueprintContents data-id="element-265" />
      <WhoIsThisFor data-id="element-266" />
      <PriceAnchor data-id="element-267" />
      <FinalCTA data-id="element-268" />
      <FloatingCTA data-id="element-269" />
      <Footer onNavigate={onNavigate} data-id="element-270" />
    </main>;
}